module.exports = __webpack_public_path__ + "static/media/sign.bed157ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/sign.svg
// module id = 123
// module chunks = 0